/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import {
  // Alert,
  Box,
  Button,
  // Divider,
  Grid,
  Paper,
  Stack,
  // TextField,
  Typography,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { alpha, keyframes, useTheme } from '@mui/material/styles';
import { Google as GoogleIcon } from '@mui/icons-material';
import CodeRoundedIcon from '@mui/icons-material/CodeRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import PolicyRoundedIcon from '@mui/icons-material/PolicyRounded';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { googleLogin } from '../../services/api';
import { getPostLoginRedirect } from '../../utils/routeAccess';
import {
  LOGIN_BTN_BG_DARK,
  LOGIN_BTN_BORDER,
  LOGIN_BTN_BORDER_DARK,
  LOGIN_BTN_BORDER_DARK_HOVER,
  LOGIN_BTN_BORDER_HOVER,
  LOGIN_BTN_SHADOW_HOVER,
  LOGIN_BTN_SHADOW_HOVER_DARK,
  LOGIN_CARD_BG_DARK,
  LOGIN_CARD_BG_LIGHT,
  LOGIN_CARD_BORDER,
  LOGIN_CARD_DIVIDER_LIGHT,
  LOGIN_CARD_SHADOW_BASE_DARK,
  LOGIN_CARD_SHADOW_BASE_LIGHT,
  LOGIN_CARD_SHADOW_HOVER_DARK,
  LOGIN_CARD_SHADOW_HOVER_LIGHT,
  LOGIN_COLUMN_EDGE_DARK,
  LOGIN_COLUMN_EDGE_LIGHT,
  LOGIN_LEFT_OVERLAY,
  LOGIN_MAIN_VEIL_DARK,
  LOGIN_MAIN_VEIL_LIGHT,
  LOGIN_RIGHT_BG_DARK,
  LOGIN_RIGHT_BG_LIGHT,
  LOGIN_SHELL_GRADIENT,
  SLATE_900,
  WHITE,
} from '../../utils/colors';
import { WELCOME_SESSION_STORAGE_KEY } from '../../components/WelcomeOverlay';
import InstitutionBrandRow from '../../components/InstitutionBrandRow';
import AmbientBackground from '../../components/AmbientBackground';
import { useBranding } from '../../context/BrandingContext';

const pageFadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

/** Card shell: scale + opacity (wrapper; tilt lives on Paper) */
const cardEnter = keyframes`
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const CARD_DEPTH_TRANSITION = '0.2s ease';
const CARD_MAX_TILT_DEG = 3;
const CARD_PARALLAX_GAIN = 0.68;

/** Feature row icons — single size for visual consistency */
const FEATURE_ICON_SX = { fontSize: 20, display: 'block' };

const BRAND_FEATURES = [
  {
    icon: <CodeRoundedIcon sx={FEATURE_ICON_SX} />,
    text: 'Monitor coding progress across batches',
  },
  {
    icon: <SchoolRoundedIcon sx={FEATURE_ICON_SX} />,
    text: 'Manage courses and assessments seamlessly',
  },
  {
    icon: <PolicyRoundedIcon sx={FEATURE_ICON_SX} />,
    text: 'Detect plagiarism with insights',
  },
];

const LoginPage = () => {
  const theme = useTheme();
  const { productName, branding } = useBranding();
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const userData = params.get('user');

    if (token && userData) {
      try {
        const decoded = decodeURIComponent(userData);
        const parsedUser = JSON.parse(decoded);
        login(parsedUser, token);
        try {
          sessionStorage.setItem(WELCOME_SESSION_STORAGE_KEY, '1');
        } catch {
          /* ignore */
        }
        navigate(getPostLoginRedirect(parsedUser.role, location.state?.from?.pathname, parsedUser), {
          replace: true,
          state: { showWelcome: true },
        });
      } catch (error) {
        console.error('Failed to parse user data', error, { rawUserData: userData });
      }
    }
  }, [location.search]);

  useEffect(() => {
    if (!user || location.pathname !== '/login') return;
    const params = new URLSearchParams(location.search);
    if (params.get('token') && params.get('user')) return;
    navigate(getPostLoginRedirect(user.role, location.state?.from?.pathname, user), { replace: true });
  }, [user, navigate, location.pathname, location.search, location.state]);

  const handleGoogleLogin = () => {
    googleLogin();
  };

  // const [pwUsername, setPwUsername] = useState('');
  // const [pwPassword, setPwPassword] = useState('');
  // const [pwFieldErrors, setPwFieldErrors] = useState({ username: '', password: '' });
  // const [pwSubmitError, setPwSubmitError] = useState('');
  // const [pwSubmitting, setPwSubmitting] = useState(false);

  // const validatePasswordForm = () => {
  //   const u = pwUsername.trim();
  //   const p = pwPassword;
  //   const next = { username: '', password: '' };
  //   if (!u) next.username = 'Username is required.';
  //   else if (u.length < 3) next.username = 'Use at least 3 characters.';
  //   else if (u.length > 128) next.username = 'Username is too long.';
  //   if (!p) next.password = 'Password is required.';
  //   else if (p.length < 8) next.password = 'Use at least 8 characters.';
  //   else if (p.length > 256) next.password = 'Password is too long.';
  //   setPwFieldErrors(next);
  //   return !next.username && !next.password;
  // };

  // const handlePasswordLogin = async (e) => {
  //   e.preventDefault();
  //   setPwSubmitError('');
  //   if (!validatePasswordForm()) return;
  //   setPwSubmitting(true);
  //   try {
  //     const data = await postPasswordLogin(pwUsername.trim(), pwPassword);
  //     if (!data?.token || !data?.user) {
  //       setPwSubmitError('Unexpected response from server.');
  //       return;
  //     }
  //     login(data.user, data.token);
  //     try {
  //       sessionStorage.setItem(WELCOME_SESSION_STORAGE_KEY, '1');
  //     } catch {
  //       /* ignore */
  //     }
  //     navigate(
  //       getPostLoginRedirect(data.user.role, location.state?.from?.pathname, data.user),
  //       { replace: true, state: { showWelcome: true } }
  //     );
  //   } catch (err) {
  //     const status = err?.response?.status;
  //     const body = err?.response?.data;
  //     if (status === 400 && body && typeof body === 'object') {
  //       const code = body.code;
  //       const msg = typeof body.message === 'string' ? body.message : 'Invalid request.';
  //       if (code === 'MISSING_CREDENTIALS' || code === 'INVALID_USERNAME') {
  //         setPwFieldErrors((prev) => ({ ...prev, username: msg }));
  //       } else if (code === 'PASSWORD_TOO_SHORT' || code === 'PASSWORD_TOO_LONG') {
  //         setPwFieldErrors((prev) => ({ ...prev, password: msg }));
  //       } else {
  //         setPwSubmitError(msg);
  //       }
  //     } else {
  //       setPwSubmitError(err?.response?.data?.message || err?.message || 'Sign-in failed.');
  //     }
  //   } finally {
  //     setPwSubmitting(false);
  //   }
  // };

  const isDark = theme.palette.mode === 'dark';
  const reduceMotion = useMediaQuery('(prefers-reduced-motion: reduce)', { defaultMatches: false });

  const [cardHover, setCardHover] = useState(false);
  const [tilt, setTilt] = useState({ rx: 0, ry: 0 });

  const handleCardMouseMove = useCallback(
    (e) => {
      if (reduceMotion) return;
      const el = e.currentTarget;
      const r = el.getBoundingClientRect();
      const dx = (e.clientX - r.left) / r.width - 0.5;
      const dy = (e.clientY - r.top) / r.height - 0.5;
      const rawRx = -dy * 2 * CARD_MAX_TILT_DEG * CARD_PARALLAX_GAIN;
      const rawRy = dx * 2 * CARD_MAX_TILT_DEG * CARD_PARALLAX_GAIN;
      setTilt({
        rx: Math.min(CARD_MAX_TILT_DEG, Math.max(-CARD_MAX_TILT_DEG, rawRx)),
        ry: Math.min(CARD_MAX_TILT_DEG, Math.max(-CARD_MAX_TILT_DEG, rawRy)),
      });
    },
    [reduceMotion],
  );

  const handleCardMouseEnter = useCallback(() => setCardHover(true), []);
  const handleCardMouseLeave = useCallback(() => {
    setCardHover(false);
    setTilt({ rx: 0, ry: 0 });
  }, []);

  const liftPx = !reduceMotion && cardHover ? -2 : 0;
  const rx = reduceMotion ? 0 : tilt.rx;
  const ry = reduceMotion ? 0 : tilt.ry;

  const primaryMain = theme.palette.primary.main;
  const cardShadowBase = isDark ? LOGIN_CARD_SHADOW_BASE_DARK : LOGIN_CARD_SHADOW_BASE_LIGHT;
  const cardShadowHover = isDark ? LOGIN_CARD_SHADOW_HOVER_DARK : LOGIN_CARD_SHADOW_HOVER_LIGHT;
  const cardFocusAccent = `0 0 0 1px ${alpha(primaryMain, 0.14)}, 0 0 20px ${alpha(primaryMain, 0.06)}`;

  return (
    <Box
      component="main"
      sx={{
        position: 'relative',
        minHeight: '100vh',
        width: '100%',
        maxWidth: '100vw',
        boxSizing: 'border-box',
        overflowX: 'hidden',
        display: 'flex',
        bgcolor: 'transparent',
        isolation: 'isolate',
        ...(!reduceMotion && {
          animation: `${pageFadeIn} 200ms ease-out both`,
        }),
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          zIndex: 0,
          pointerEvents: 'none',
          bgcolor: isDark ? LOGIN_MAIN_VEIL_DARK : LOGIN_MAIN_VEIL_LIGHT,
        },
      }}
    >
      <AmbientBackground />
      <Grid
        container
        direction={{ xs: 'column', md: 'row' }}
        wrap="nowrap"
        sx={{
          position: 'relative',
          zIndex: 1,
          flex: 1,
          minHeight: '100vh',
          m: 0,
          width: '100%',
          maxWidth: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Grid
          item
          xs={12}
          md={7}
          sx={{
            display: { xs: 'none', md: 'flex' },
            flexDirection: 'column',
            justifyContent: 'center',
            alignSelf: 'stretch',
            minHeight: { md: '100vh' },
            width: '100%',
            boxSizing: 'border-box',
            px: { md: 6, lg: 8 },
            py: { md: 8 },
            background: LOGIN_SHELL_GRADIENT,
            position: 'relative',
            overflow: 'hidden',
            '&::after': {
              content: '""',
              position: 'absolute',
              inset: 0,
              zIndex: 0,
              background: LOGIN_LEFT_OVERLAY,
              pointerEvents: 'none',
            },
          }}
        >
          <Box
            sx={{
              position: 'relative',
              zIndex: 1,
              width: '100%',
              maxWidth: '100%',
              boxSizing: 'border-box',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'stretch',
                gap: 2,
                mb: 3,
              }}
            >
              <Box
                aria-hidden
                sx={{
                  width: 3,
                  flexShrink: 0,
                  borderRadius: 1,
                  background: alpha('#fff', 0.35),
                  alignSelf: 'stretch',
                  minHeight: 48,
                }}
              />
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <InstitutionBrandRow
                  size="lg"
                  variant="h5"
                  logoHeight={44}
                  nameColor="#FFFFFF"
                  sx={{
                    alignItems: 'center',
                    '& .MuiTypography-root': { fontWeight: 500, lineHeight: 1.35 },
                  }}
                />
                {Boolean(branding.shortName?.trim()) &&
                  branding.name?.trim() &&
                  branding.name.trim() !== branding.shortName.trim() && (
                    <Typography
                      variant="body2"
                      component="p"
                      sx={{
                        mt: 2,
                        color: alpha('#FFFFFF', 0.8),
                        fontWeight: 400,
                        letterSpacing: '0.01em',
                        lineHeight: 1.55,
                        maxWidth: 420,
                      }}
                    >
                      {branding.name}
                    </Typography>
                  )}
              </Box>
            </Box>

            <Typography
              variant="subtitle2"
              component="p"
              sx={{
                fontWeight: 500,
                color: alpha('#FFFFFF', 0.8),
                mb: 4,
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                fontSize: '0.75rem',
                lineHeight: 1.5,
              }}
            >
              Track. Analyze. Improve.
            </Typography>

            <Stack spacing={4}>
              {BRAND_FEATURES.map(({ icon, text }) => (
                <Box
                  key={text}
                  sx={{
                    display: 'flex',
                    gap: 2,
                    alignItems: 'center',
                  }}
                >
                  <Box
                    sx={{
                      flexShrink: 0,
                      width: 36,
                      height: 36,
                      borderRadius: 1.25,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: alpha('#FFFFFF', 0.08),
                      border: `1px solid ${alpha('#FFFFFF', 0.12)}`,
                      color: '#FFFFFF',
                      '& svg': { fontSize: 20, width: 20, height: 20 },
                    }}
                  >
                    {icon}
                  </Box>
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      color: alpha('#FFFFFF', 0.88),
                      lineHeight: 1.6,
                      fontWeight: 400,
                      letterSpacing: '0.01em',
                      flex: 1,
                      minWidth: 0,
                    }}
                  >
                    {text}
                  </Typography>
                </Box>
              ))}
            </Stack>

            <Typography
              variant="caption"
              component="p"
              sx={{
                mt: 6,
                color: alpha('#FFFFFF', 0.45),
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                fontSize: '0.65rem',
                fontWeight: 400,
                lineHeight: 1.5,
              }}
            >
              Powered by {productName}
            </Typography>
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          md={5}
          sx={{
            alignSelf: 'stretch',
            minHeight: { xs: 'auto', md: '100vh' },
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            position: 'relative',
            overflow: 'hidden',
            background: isDark ? LOGIN_RIGHT_BG_DARK : LOGIN_RIGHT_BG_LIGHT,
            '&::before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              width: { md: 56, xs: 0 },
              background: isDark ? LOGIN_COLUMN_EDGE_DARK : LOGIN_COLUMN_EDGE_LIGHT,
              pointerEvents: 'none',
              zIndex: 0,
            },
          }}
        >
          <Box
            sx={{
              position: 'relative',
              zIndex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: { xs: 'center', md: 'flex-start' },
              minHeight: { xs: 'auto', md: '100vh' },
              width: '100%',
              maxWidth: '100%',
              boxSizing: 'border-box',
              px: { xs: 2, sm: 4, md: 6 },
              py: { xs: 6, md: 8 },
            }}
          >
            <Box sx={{ maxWidth: 420, width: '100%', boxSizing: 'border-box' }}>
              <Box
                onMouseEnter={handleCardMouseEnter}
                onMouseMove={handleCardMouseMove}
                onMouseLeave={handleCardMouseLeave}
                sx={{
                  width: '100%',
                  borderRadius: '16px',
                  ...(!reduceMotion && {
                    animation: `${cardEnter} 0.4s ease-out both`,
                  }),
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    p: { xs: 4, sm: 6 },
                    borderRadius: '16px',
                    border: `1px solid ${LOGIN_CARD_BORDER}`,
                    bgcolor: isDark ? LOGIN_CARD_BG_DARK : LOGIN_CARD_BG_LIGHT,
                    backdropFilter: 'blur(12px)',
                    WebkitBackdropFilter: 'blur(12px)',
                    boxShadow: cardHover && !reduceMotion ? cardShadowHover : cardShadowBase,
                    transform: `translateY(${liftPx}px) perspective(1200px) rotateX(${rx}deg) rotateY(${ry}deg)`,
                    transformOrigin: 'center center',
                    transformStyle: 'preserve-3d',
                    transition: reduceMotion
                      ? `box-shadow ${CARD_DEPTH_TRANSITION}, border-color ${CARD_DEPTH_TRANSITION}`
                      : cardHover
                        ? `box-shadow ${CARD_DEPTH_TRANSITION}, border-color ${CARD_DEPTH_TRANSITION}`
                        : `transform ${CARD_DEPTH_TRANSITION}, box-shadow ${CARD_DEPTH_TRANSITION}, border-color ${CARD_DEPTH_TRANSITION}`,
                    willChange: reduceMotion ? undefined : 'transform',
                    '&:focus-within': {
                      boxShadow: `${cardHover && !reduceMotion ? cardShadowHover : cardShadowBase}, ${cardFocusAccent}`,
                    },
                  }}
                >
                <Box
                  sx={{
                    pb: 2.25,
                    mb: 3.25,
                    borderBottom: (t) =>
                      `1px solid ${isDark ? alpha(t.palette.divider, 0.35) : LOGIN_CARD_DIVIDER_LIGHT}`,
                  }}
                >
                  <InstitutionBrandRow
                    size="md"
                    variant="subtitle1"
                    logoHeight={36}
                    nameColor="text.primary"
                    sx={{
                      alignItems: 'center',
                      '& .MuiTypography-root': {
                        fontWeight: 500,
                        fontSize: '1rem',
                        lineHeight: 1.5,
                      },
                    }}
                  />
                </Box>

                <Typography
                  variant="h5"
                  component="h2"
                  fontWeight={500}
                  sx={{
                    letterSpacing: '-0.02em',
                    mb: 2,
                    lineHeight: 1.45,
                    fontSize: { xs: '1.25rem', sm: '1.3125rem' },
                  }}
                >
                  Welcome back
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    mb: 3.5,
                    fontWeight: 400,
                    opacity: 0.82,
                    fontSize: '0.875rem',
                    lineHeight: 1.6,
                  }}
                >
                  Sign in to continue
                </Typography>

                <Button
                  fullWidth
                  variant="outlined"
                  size="large"
                  startIcon={<GoogleIcon sx={{ fontSize: 20 }} />}
                  onClick={handleGoogleLogin}
                  sx={{
                    py: 1.5,
                    borderRadius: '12px',
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '0.9375rem',
                    lineHeight: 1.55,
                    borderColor: LOGIN_BTN_BORDER,
                    color: SLATE_900,
                    bgcolor: WHITE,
                    boxShadow: 'none',
                    transition:
                      'background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease',
                    '&:hover': {
                      borderColor: LOGIN_BTN_BORDER_HOVER,
                      bgcolor: WHITE,
                      boxShadow: LOGIN_BTN_SHADOW_HOVER,
                      transform: 'translateY(-1px)',
                    },
                    '&.Mui-focusVisible': {
                      outline: 'none',
                      borderColor: alpha(primaryMain, 0.35),
                      boxShadow: `0 0 0 2px ${alpha(primaryMain, 0.12)}, 0 0 16px ${alpha(primaryMain, 0.06)}`,
                      bgcolor: WHITE,
                    },
                    ...(isDark && {
                      color: alpha(SLATE_900, 0.92),
                      borderColor: LOGIN_BTN_BORDER_DARK,
                      bgcolor: LOGIN_BTN_BG_DARK,
                      '&:hover': {
                        borderColor: LOGIN_BTN_BORDER_DARK_HOVER,
                        bgcolor: WHITE,
                        boxShadow: LOGIN_BTN_SHADOW_HOVER_DARK,
                        transform: 'translateY(-1px)',
                      },
                      '&.Mui-focusVisible': {
                        borderColor: alpha(primaryMain, 0.45),
                        boxShadow: `0 0 0 2px ${alpha(primaryMain, 0.15)}, 0 0 16px ${alpha(primaryMain, 0.08)}`,
                        bgcolor: LOGIN_BTN_BG_DARK,
                      },
                    }),
                  }}
                >
                  Continue with Google
                </Button>

                {/* <Divider sx={{ my: 3 }}>
                  <Typography variant="caption" color="text.secondary" sx={{ px: 1 }}>
                    Or username & password
                  </Typography>
                </Divider>

                <Box component="form" onSubmit={handlePasswordLogin} noValidate>
                  {pwSubmitError ? (
                    <Alert severity="error" sx={{ mb: 2 }} onClose={() => setPwSubmitError('')}>
                      {pwSubmitError}
                    </Alert>
                  ) : null}
                  <Stack spacing={2}>
                    <TextField
                      label="Username"
                      name="username"
                      autoComplete="username"
                      value={pwUsername}
                      onChange={(ev) => {
                        setPwUsername(ev.target.value);
                        if (pwFieldErrors.username) setPwFieldErrors((p) => ({ ...p, username: '' }));
                      }}
                      error={Boolean(pwFieldErrors.username)}
                      helperText={pwFieldErrors.username || undefined}
                      disabled={pwSubmitting}
                      size="medium"
                      fullWidth
                    />
                    <TextField
                      label="Password"
                      name="password"
                      type="password"
                      autoComplete="current-password"
                      value={pwPassword}
                      onChange={(ev) => {
                        setPwPassword(ev.target.value);
                        if (pwFieldErrors.password) setPwFieldErrors((p) => ({ ...p, password: '' }));
                      }}
                      error={Boolean(pwFieldErrors.password)}
                      helperText={pwFieldErrors.password || 'Minimum 8 characters'}
                      disabled={pwSubmitting}
                      size="medium"
                      fullWidth
                    />
                    <Button type="submit" variant="contained" size="large" disabled={pwSubmitting} fullWidth sx={{ py: 1.25, borderRadius: '12px', textTransform: 'none', fontWeight: 600 }}>
                      {pwSubmitting ? 'Signing in…' : 'Sign in'}
                    </Button>
                  </Stack>
                </Box> */}

                <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 2, lineHeight: 1.5 }}>
                  Tip: where Git history is scored, increase commit frequency and use clear messages so reviewers can
                  follow your progress.
                </Typography>

                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                  textAlign="center"
                  sx={{
                    mt: 3,
                    letterSpacing: '0.01em',
                    opacity: 0.72,
                    fontSize: '0.75rem',
                    lineHeight: 1.5,
                    fontWeight: 400,
                  }}
                >
                  For students and faculty
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                  textAlign="center"
                  sx={{
                    mt: 2,
                    opacity: 0.38,
                    letterSpacing: '0.05em',
                    textTransform: 'uppercase',
                    fontSize: '0.625rem',
                    lineHeight: 1.5,
                    fontWeight: 400,
                  }}
                >
                  Powered by {productName}
                </Typography>
                </Paper>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LoginPage;
